import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpIcon from '@mui/icons-material/Help';
import LogoutIcon from '@mui/icons-material/Logout';
import UserContext from '../contexts/userContext';
import ApiContext from '../contexts/apiContext';
import HelpDialog from './HelpDialog';
var Header = function () {
    var user = useContext(UserContext).user;
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _a = useState(false), helpDialogOpen = _a[0], setHelpDialogOpen = _a[1];
    var handleHelpButtonClick = function () { return setHelpDialogOpen(true); };
    var handleHelpDialogClose = function () { return setHelpDialogOpen(false); };
    return (_jsxs(_Fragment, { children: [_jsx(HelpDialog, { open: helpDialogOpen, onClose: handleHelpDialogClose }), _jsx(Box, { position: "fixed", right: 0, bottom: 0, pb: 2, pr: 2, zIndex: 2, children: _jsx(Fab, { size: "small", onClick: handleHelpButtonClick, children: _jsx(HelpIcon, {}) }) }), _jsx(AppBar, { position: "static", children: _jsxs(Toolbar, { children: [_jsx(Box, { flexGrow: 1, justifyContent: "flex-start", children: _jsx(Tooltip, { title: "Back to search", children: _jsx(IconButton, { href: "/", children: _jsx(ArrowBackIcon, {}) }) }) }), _jsx(Typography, { children: user === null || user === void 0 ? void 0 : user.displayName }), _jsx(Tooltip, { title: "Logout", children: _jsx(IconButton, { href: "".concat(apiBaseUrl, "/auth/logout?redirectUrl=").concat(new URL('/logged-out', window.location.href)), children: _jsx(LogoutIcon, {}) }) })] }) })] }));
};
export default Header;
